module.exports = __webpack_public_path__ + "static/dongpo-3c213ea695e1559b38afa7c6c4e6a6f8.png";